import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SimpleCachingService {
      
  private cachingDictionary: { [key: string]: any; } = {};

  constructor() { }

  cacheValue<T>(key: string, value: T) {
    this.cachingDictionary[key] = value;
  }

  getValue<T>(key: string) {
    if (this.cachingDictionary[key]) {
        return this.cachingDictionary[key] as T;
    }
  }

  invalidate(keys: string[])
  {
    keys.forEach(key => {
      if(this.cachingDictionary[key]){
        delete this.cachingDictionary[key];
      }
    });
  }
}